import { render, staticRenderFns } from "./developer_manage.vue?vue&type=template&id=5c0f2eee&scoped=true"
import script from "./developer_manage.vue?vue&type=script&setup=true&lang=js"
export * from "./developer_manage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./developer_manage.vue?vue&type=style&index=0&id=5c0f2eee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0f2eee",
  null
  
)

export default component.exports